import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { validarCPF } from "../../helpers/validar";

import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import api from "../../services/api";
import CustomizedSnackbars from "../../components/alert/Alert";
import logo from "../../images/perto-logo.png";
import { Grid } from "@mui/material";

let text = "";
let tipo = "";

export default function RecuperarSenha() {
  const [CPF, setCPF] = useState("");
  const history = useHistory();
  const [alerta, setAlerta] = useState(false);
  const [fim, setFim] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validarCPF(CPF)) {
      text = "CPF inválido";
      tipo = "warning";
      alertMsg();
      return;
    }

    const params = {
      CPF,
      email: "",
      canal: "painel-admin",
    };

    api
      .post("usuarios/solicitarRedefinicaoSenha", params)
      .then((res) => {
        setFim(true);
        text = `Um link de redefinição foi enviado para ${res.email}.`;
        tipo = "success";
        alertMsg();
        return;
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            text = `Usuário com email inválido`;
            tipo = "error";
            alertMsg();
            return;
          case 2:
            text = `Configuração incorreta de parâmetros para geração do link de recuperação`;
            tipo = "error";
            alertMsg();
            return;

          default:
            text = `Dados inválidos`;
            tipo = "error";
            alertMsg();
            return;
        }
      });
  };

  const alertMsg = () => {
    setAlerta(true);
    setTimeout(() => setAlerta(false), 3000);
  };

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: "1%" }}
      >
        <div
          style={{
            width: window.innerWidth < 800 ? "100%" : "450px",
            backgroundColor: "white",
            textAlign: "center",
            borderRadius: "50px",
          }}
        >
          <form onSubmit={handleSubmit}>
            <div
              style={{
                background: "#f7af14",
                borderRadius: "50px",
                padding: 20,
                color: "white",
                marginBottom: 30,
              }}
            >
              <img src={logo} alt="logo" style={{ width: 200 }} />
              <h4>Recuperação de senha</h4>
            </div>
            <span style={{ fontSize: 18 }}>
              Informe seu CPF para solicitar a redefinição de senha
            </span>
            <Stack spacing={1} sx={{ width: "100%" }}>
              <TextField
                style={{ margin: "30px", background: "#FFFF" }}
                id="CPF"
                label="CPF"
                variant="outlined"
                onChange={(event) => setCPF(event.target.value)}
              />

              {!fim ? (
                <div
                  style={{
                    paddingLeft: 10,
                    paddingRight: 10,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    style={{ color: "white", marginBottom: 30 }}
                    color="primary"
                    type="submit"
                    variant="contained"
                    fullWidth
                  >
                    Solicitar
                  </Button>
                  <a
                    style={{ color: "black", fontSize: "1.2rem", padding: 10 }}
                    href="/login"
                  >
                    Ir para o login
                  </a>
                </div>
              ) : (
                <Button
                  style={{ margin: "30px", color: "white" }}
                  color="info"
                  onClick={() => history.push(`/login`)}
                  variant="contained"
                >
                  Voltar
                </Button>
              )}
            </Stack>
            {alerta && (
              <CustomizedSnackbars
                texto={text}
                tipo={tipo}
              ></CustomizedSnackbars>
            )}
          </form>
        </div>
      </Grid>
    </div>
  );
}
